<script type="text/javascript">
    import AppStore from '../../AppStore';
    import AuthStore from '../../Auth/Store';
    import AlertsStore from '../../Alerts/Store';
    import AlertType from '../../Alerts/AlertType';
    import LoadState from '../../Enums/LoadState';
    import MapLayerManager from '../../Map/MapLayerManager';
    import MapStore from '../../Map/Store';
    import ModalWindow from '../ModalWindow.svelte';
    import CablesStore from './CablesStore';

    import "../../UI/LayerList/LayerList.scss";
	import LayerListSwitch from "../../UI/LayerList/LayerListSwitch.svelte";
    import IconMode from '../../Map/Enums/IconMode';
    import KeyColors from '../Key/KeyColors.svelte';
import User from '../../Branding/User';
import Feature from '../../Branding/Feature';


    let mapInitialised = MapStore.meta.initialised;
    let visible = CablesStore.meta.visible;
    let loadState = CablesStore.meta.loadState;
    let mapLayersInitted = CablesStore.meta.mapLayersInitted;

    let linesVisibility = CablesStore.meta.visibility.lines;
	let buffersVisibility = CablesStore.meta.visibility.buffers;
	let pointsVisibility = CablesStore.meta.visibility.points; // finish

    let isMounted = false;
    let vessels = AlertsStore.vesselGroup.vessels;
    let hasRim = AlertsStore.filters.alertTypes[AlertType.RIM].exists;
    let user = AuthStore.session.user;

    $: {
        if ($mapInitialised) {
            if (!isMounted && $vessels.length > 0) {
                if ($hasRim && User.hasFeature(Feature.MARITIME.NATIONALGRID.UNDERSEA_CABLES.VIEW)) {
                    $visible = true;
                }
                isMounted = true;
            }
            if ($visible) {
                // TODO: set to auto-visible if it has the permission!
                CablesStore.actions.initMap( MapStore.helpers.getMap());
                CablesStore.actions.init();
            }
            else {
                CablesStore.actions.deinitMap( );
            }
            $mapLayersInitted;
            MapLayerManager.reorderLayerGroups();
            MapLayerManager.updateVisibleLayers();
        }
	};
    $: {
        if ($mapInitialised) {
            $linesVisibility;
            $buffersVisibility;
            $pointsVisibility;
            MapLayerManager.updateVisibleLayers();
        }
    }
    
</script>


<ModalWindow
	title={`Undersea Cables`}
	hasCloseButton={true}
	hasBackground={false}
	resizable={true}
	draggable={true}
	fullscreen={false}
	padding={true}
	position="top-right"
	height="70%"
	bind:open={$visible} >
        
    {#if $loadState !== LoadState.LOADED}
        <p>Loading...</p>
    {:else}
        <!-- <p>Loaded BritNed cable. See map.</p> -->

        <h2>BritNed Cable</h2>
        <LayerListSwitch label={"Line"} bind:checked={$linesVisibility} />
        <LayerListSwitch label={"Points"} bind:checked={$pointsVisibility} />
        <LayerListSwitch label={"Buffer Zone"} bind:checked={$buffersVisibility} />

        <h2>Risk Levels</h2>
        <KeyColors iconMode={IconMode.RISK_LEVEL}/>
        
    {/if}
    
</ModalWindow>